module.exports = __webpack_public_path__ + "img/banner.cebf0f19.png";